import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { getText } from 'helpers/language-helper';
import {usePreview} from 'react-dnd-preview';
import './order-push-dnd-preview.scss';

const OrderPushDndPreview = ({orderedItems, itemsData, languageId}) => {
	const [touchPositionX, setTouchPositionX] = useState(null);

	const [isHoldingRight, setIsHoldingRight] = useState(false);

	useEffect(() => {
		/* Setting event listeners */
		const itemsDiv = document.getElementById('orderItems');
		
		itemsDiv.addEventListener(
			'touchstart',
			(e) => {
				if (!touchPositionX) {
					setTouchPositionX(e.touches[0].clientX);
				}
			},
			false
		);

		itemsDiv.addEventListener(
			'touchend',
			(e) => {
				setTouchPositionX(null);
			},
			false
		);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (touchPositionX) {
			const itemsDiv = document.getElementById('orderItems');
			
			const rect = itemsDiv.getBoundingClientRect();
			const rectMiddle = rect.x + rect.width / 2;
			setIsHoldingRight(touchPositionX > rectMiddle);
		}
	}, [touchPositionX]);

	let {display, item, style} = usePreview();
	if (!display) return null;

	/* Item data */
	const itemId = orderedItems[item.index].id;
	const itemData = itemsData.find((i) => {return i.id === itemId;});

	return (
		<div className={'OrderPushDndPreview'} style={style} >
			<div className={'OrderPushDndPreview-item' + (isHoldingRight ? ' right' : ' left')}>
				<span>{itemData ? getText(itemData.text, languageId) : null}</span>
			</div>
		</div>
	);
};

OrderPushDndPreview.propTypes = {
	orderedItems: PropTypes.array.isRequired,
	itemsData: PropTypes.array.isRequired,
	languageId: PropTypes.string.isRequired,
};

export default OrderPushDndPreview;